const xssWhiteList = {
  html: ['lang'],
  '!doctype': ['html'],
  style: [],
  title: [],
  head: [],
  meta: ['content', 'charset', 'http-equiv', 'name'],
  link: ['rel', 'href', 'type'],
  a: ['class', 'style', 'target', 'href', 'title'],
  abbr: ['title'],
  address: ['class', 'style'],
  article: ['class', 'style'],
  aside: [],
  audio: ['class', 'style', 'autoplay', 'controls', 'loop', 'preload', 'src'],
  b: ['class', 'style'],
  bdi: ['dir'],
  bdo: ['dir'],
  big: [],
  blockquote: ['cite'],
  br: [],
  caption: ['class', 'style'],
  center: ['class', 'style'],
  cite: [],
  code: ['class', 'style'],
  col: ['class', 'style', 'align', 'valign', 'span', 'width'],
  colgroup: ['class', 'style', 'align', 'valign', 'span', 'width'],
  dd: [],
  del: ['datetime'],
  details: ['open'],
  div: ['class', 'style'],
  dl: ['class', 'style'],
  dt: ['class', 'style'],
  em: ['class', 'style'],
  font: ['class', 'style', 'color', 'size', 'face'],
  footer: ['class', 'style'],
  'h1,h2,h3,h4,h5,h6': ['class', 'style'],
  'header,hr,i': ['class', 'style'],
  input: ['style', 'type', 'value'],
  img: ['class', 'style', 'src', 'alt', 'title', 'width', 'height'],
  ins: ['datetime'],
  li: ['class', 'style'],
  mark: ['class', 'style'],
  nav: ['class', 'style'],
  ol: ['class', 'style'],
  p: ['class', 'style'],
  pre: ['class', 'style'],
  s: ['class', 'style'],
  section: ['class', 'style'],
  small: ['class', 'style'],
  span: ['class', 'style'],
  sub: ['class', 'style'],
  sup: ['class', 'style'],
  strong: ['class', 'style'],
  table: ['class', 'style', 'width', 'border', 'align', 'valign'],
  tbody: ['class', 'style', 'align', 'valign'],
  td: ['class', 'style', 'width', 'rowspan', 'colspan', 'align', 'valign'],
  tfoot: ['class', 'style', 'align', 'valign'],
  th: ['class', 'style', 'width', 'rowspan', 'colspan', 'align', 'valign'],
  thead: ['class', 'style', 'align', 'valign'],
  tr: ['class', 'style', 'rowspan', 'align', 'valign'],
  tt: ['class', 'style'],
  u: ['class', 'style'],
  ul: ['class', 'style'],
  video: [
    'class',
    'style',
    'autoplay',
    'controls',
    'loop',
    'preload',
    'src',
    'height',
    'width',
  ],
  form: ['class', 'style', 'height', 'width'],
  /* 'html': ['lang'],
  'head,title,style,br': [],
  'meta': ['content','charset','http-equiv', 'name'],
  'link': ['rel','href','type'],
  'body,table,tr,td,tbody,thead,th,tfoot,div,span,p,b,pre,strong,em,ul,ol,li,h1,h2,h3,h4,h5,h6': ['class', 'style'],
  'a': ['class', 'style', 'href'],
  'img': ['class', 'style', 'src', 'alt', 'height', 'width'],
  '!doctype': ['html'] */
};
const xssOptions = {
  stripIgnoreTagBody: ['script', 'cake'],
  onIgnoreTag: function onIgnoreTag() {
    return '';
  },
  onTagAttr: function onTagAttr(tag, name, value, isWhiteAttr) {
    // 处理base64的图片（会被xss默认处理过滤）
    if (
      isWhiteAttr &&
      tag === 'img' &&
      name === 'src' &&
      /^data:/.test(value)
    ) {
      return `${name}="${value}"`;
    }
  },
  css: false,
  whiteList: (function buildList(list) {
    const whiteList = {};
    for (const key in list) {
      const keys = key.split(',');
      for (let i = 0; i < keys.length; i++) {
        whiteList[keys[i]] = list[key];
      }
    }
    return whiteList;
  }(xssWhiteList)),
};
export default xssOptions;
